const MIN_AZW_VALUE = 2.0;
const MAX_AZW_VALUE = 50.0;

/** Validates AZW (Anzulegender Wert) for plausibility. Returns warning message if value is outside typical range of 2.00 to 50.00 ct/kWh. */
export function validateAZWValue(
  value: string | number | null | undefined
): string | undefined {
  if (value === null || value === undefined || value === "") return undefined;

  const numericValue = Number(value);
  if (isNaN(numericValue)) return undefined;

  if (numericValue < MIN_AZW_VALUE) {
    return "Wert ist unüblich klein. Bitte fahren Sie nur fort, wenn Sie sicher sind.";
  }

  if (numericValue > MAX_AZW_VALUE) {
    return "Wert ist unüblich groß. Bitte fahren Sie nur fort, wenn Sie sicher sind.";
  }

  return undefined;
}
